import { useEffect } from 'react'
import NProgress from 'nprogress'
import FavPage from '../components/extension/fav'

function Fav() {
  useEffect(() => NProgress.start(), [])

  return <FavPage />
}

export default Fav
